"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _AppApisV1RecurrentSchedulesListSchedules200Response = _interopRequireDefault(require("../model/AppApisV1RecurrentSchedulesListSchedules200Response"));

var _Delivery = _interopRequireDefault(require("../model/Delivery"));

var _Errors = _interopRequireDefault(require("../model/Errors"));

var _EventCreationRequest = _interopRequireDefault(require("../model/EventCreationRequest"));

var _EventDeletionRequest = _interopRequireDefault(require("../model/EventDeletionRequest"));

var _EventEditionRequest = _interopRequireDefault(require("../model/EventEditionRequest"));

var _EventGetRequest = _interopRequireDefault(require("../model/EventGetRequest"));

var _EventSkipDayRequest = _interopRequireDefault(require("../model/EventSkipDayRequest"));

var _EventsList = _interopRequireDefault(require("../model/EventsList"));

var _EventsListRequest = _interopRequireDefault(require("../model/EventsListRequest"));

var _RecurrentSchedule = _interopRequireDefault(require("../model/RecurrentSchedule"));

var _RecurrentScheduleCreationRequest = _interopRequireDefault(require("../model/RecurrentScheduleCreationRequest"));

var _RecurrentScheduleUpdateRequest = _interopRequireDefault(require("../model/RecurrentScheduleUpdateRequest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* DeliverSchedules service.
* @module api/DeliverSchedulesApi
* @version 1.126
*/
var DeliverSchedulesApi = /*#__PURE__*/function () {
  /**
  * Constructs a new DeliverSchedulesApi. 
  * @alias module:api/DeliverSchedulesApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function DeliverSchedulesApi(apiClient) {
    _classCallCheck(this, DeliverSchedulesApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Create events for multiple locations
   * **scope**: schedules:write 
   * @param {module:model/EventCreationRequest} eventCreationRequest Event creation request
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1RecurrentSchedulesListSchedules200Response} and HTTP response
   */


  _createClass(DeliverSchedulesApi, [{
    key: "appApisV1RecurrentSchedulesCreateEventWithHttpInfo",
    value: function appApisV1RecurrentSchedulesCreateEventWithHttpInfo(eventCreationRequest) {
      var postBody = eventCreationRequest; // verify the required parameter 'eventCreationRequest' is set

      if (eventCreationRequest === undefined || eventCreationRequest === null) {
        throw new Error("Missing the required parameter 'eventCreationRequest' when calling appApisV1RecurrentSchedulesCreateEvent");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AppApisV1RecurrentSchedulesListSchedules200Response["default"];
      return this.apiClient.callApi('/recurrent-schedules/add-new-event', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create events for multiple locations
     * **scope**: schedules:write 
     * @param {module:model/EventCreationRequest} eventCreationRequest Event creation request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1RecurrentSchedulesListSchedules200Response}
     */

  }, {
    key: "appApisV1RecurrentSchedulesCreateEvent",
    value: function appApisV1RecurrentSchedulesCreateEvent(eventCreationRequest) {
      return this.appApisV1RecurrentSchedulesCreateEventWithHttpInfo(eventCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Create a new recurrent delivery schedule
     * **scope**: schedules:write 
     * @param {module:model/RecurrentScheduleCreationRequest} recurrentScheduleCreationRequest Recurrent Schedule
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/RecurrentSchedule} and HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesCreateScheduleWithHttpInfo",
    value: function appApisV1RecurrentSchedulesCreateScheduleWithHttpInfo(recurrentScheduleCreationRequest) {
      var postBody = recurrentScheduleCreationRequest; // verify the required parameter 'recurrentScheduleCreationRequest' is set

      if (recurrentScheduleCreationRequest === undefined || recurrentScheduleCreationRequest === null) {
        throw new Error("Missing the required parameter 'recurrentScheduleCreationRequest' when calling appApisV1RecurrentSchedulesCreateSchedule");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _RecurrentSchedule["default"];
      return this.apiClient.callApi('/recurrent-schedules', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a new recurrent delivery schedule
     * **scope**: schedules:write 
     * @param {module:model/RecurrentScheduleCreationRequest} recurrentScheduleCreationRequest Recurrent Schedule
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/RecurrentSchedule}
     */

  }, {
    key: "appApisV1RecurrentSchedulesCreateSchedule",
    value: function appApisV1RecurrentSchedulesCreateSchedule(recurrentScheduleCreationRequest) {
      return this.appApisV1RecurrentSchedulesCreateScheduleWithHttpInfo(recurrentScheduleCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete events for multiple locations
     * **scope**: schedules:write 
     * @param {module:model/EventDeletionRequest} eventDeletionRequest Event deletion request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1RecurrentSchedulesListSchedules200Response} and HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesDeleteEventWithHttpInfo",
    value: function appApisV1RecurrentSchedulesDeleteEventWithHttpInfo(eventDeletionRequest) {
      var postBody = eventDeletionRequest; // verify the required parameter 'eventDeletionRequest' is set

      if (eventDeletionRequest === undefined || eventDeletionRequest === null) {
        throw new Error("Missing the required parameter 'eventDeletionRequest' when calling appApisV1RecurrentSchedulesDeleteEvent");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AppApisV1RecurrentSchedulesListSchedules200Response["default"];
      return this.apiClient.callApi('/recurrent-schedules/end-event', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete events for multiple locations
     * **scope**: schedules:write 
     * @param {module:model/EventDeletionRequest} eventDeletionRequest Event deletion request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1RecurrentSchedulesListSchedules200Response}
     */

  }, {
    key: "appApisV1RecurrentSchedulesDeleteEvent",
    value: function appApisV1RecurrentSchedulesDeleteEvent(eventDeletionRequest) {
      return this.appApisV1RecurrentSchedulesDeleteEventWithHttpInfo(eventDeletionRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete recurrent schedule
     * **scope**: schedules:admin 
     * @param {String} recurrentScheduleUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesDeleteScheduleWithHttpInfo",
    value: function appApisV1RecurrentSchedulesDeleteScheduleWithHttpInfo(recurrentScheduleUuid) {
      var postBody = null; // verify the required parameter 'recurrentScheduleUuid' is set

      if (recurrentScheduleUuid === undefined || recurrentScheduleUuid === null) {
        throw new Error("Missing the required parameter 'recurrentScheduleUuid' when calling appApisV1RecurrentSchedulesDeleteSchedule");
      }

      var pathParams = {
        'recurrent_schedule_uuid': recurrentScheduleUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/recurrent-schedules/{recurrent_schedule_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete recurrent schedule
     * **scope**: schedules:admin 
     * @param {String} recurrentScheduleUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1RecurrentSchedulesDeleteSchedule",
    value: function appApisV1RecurrentSchedulesDeleteSchedule(recurrentScheduleUuid) {
      return this.appApisV1RecurrentSchedulesDeleteScheduleWithHttpInfo(recurrentScheduleUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get an event an (multiple schedules in multiple locations with same parameters)
     * **scope**: schedules:read 
     * @param {module:model/EventGetRequest} eventGetRequest Event get request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Delivery} and HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesGetEventWithHttpInfo",
    value: function appApisV1RecurrentSchedulesGetEventWithHttpInfo(eventGetRequest) {
      var postBody = eventGetRequest; // verify the required parameter 'eventGetRequest' is set

      if (eventGetRequest === undefined || eventGetRequest === null) {
        throw new Error("Missing the required parameter 'eventGetRequest' when calling appApisV1RecurrentSchedulesGetEvent");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Delivery["default"];
      return this.apiClient.callApi('/recurrent-schedules/describe-event', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get an event an (multiple schedules in multiple locations with same parameters)
     * **scope**: schedules:read 
     * @param {module:model/EventGetRequest} eventGetRequest Event get request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Delivery}
     */

  }, {
    key: "appApisV1RecurrentSchedulesGetEvent",
    value: function appApisV1RecurrentSchedulesGetEvent(eventGetRequest) {
      return this.appApisV1RecurrentSchedulesGetEventWithHttpInfo(eventGetRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get recurrent schedule
     * **scope**: schedules:read 
     * @param {String} recurrentScheduleUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/RecurrentSchedule} and HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesGetScheduleWithHttpInfo",
    value: function appApisV1RecurrentSchedulesGetScheduleWithHttpInfo(recurrentScheduleUuid) {
      var postBody = null; // verify the required parameter 'recurrentScheduleUuid' is set

      if (recurrentScheduleUuid === undefined || recurrentScheduleUuid === null) {
        throw new Error("Missing the required parameter 'recurrentScheduleUuid' when calling appApisV1RecurrentSchedulesGetSchedule");
      }

      var pathParams = {
        'recurrent_schedule_uuid': recurrentScheduleUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _RecurrentSchedule["default"];
      return this.apiClient.callApi('/recurrent-schedules/{recurrent_schedule_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get recurrent schedule
     * **scope**: schedules:read 
     * @param {String} recurrentScheduleUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/RecurrentSchedule}
     */

  }, {
    key: "appApisV1RecurrentSchedulesGetSchedule",
    value: function appApisV1RecurrentSchedulesGetSchedule(recurrentScheduleUuid) {
      return this.appApisV1RecurrentSchedulesGetScheduleWithHttpInfo(recurrentScheduleUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * List all events
     * **scope**: schedules:read 
     * @param {module:model/EventsListRequest} eventsListRequest Events list request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/EventsList} and HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesListEventsWithHttpInfo",
    value: function appApisV1RecurrentSchedulesListEventsWithHttpInfo(eventsListRequest) {
      var postBody = eventsListRequest; // verify the required parameter 'eventsListRequest' is set

      if (eventsListRequest === undefined || eventsListRequest === null) {
        throw new Error("Missing the required parameter 'eventsListRequest' when calling appApisV1RecurrentSchedulesListEvents");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _EventsList["default"];
      return this.apiClient.callApi('/recurrent-schedules/get-timeline', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * List all events
     * **scope**: schedules:read 
     * @param {module:model/EventsListRequest} eventsListRequest Events list request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/EventsList}
     */

  }, {
    key: "appApisV1RecurrentSchedulesListEvents",
    value: function appApisV1RecurrentSchedulesListEvents(eventsListRequest) {
      return this.appApisV1RecurrentSchedulesListEventsWithHttpInfo(eventsListRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * List upcoming delivery to orders for a kitchen's location within a date range
     * **scope**: schedules:read 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @param {Date} opts.startDate The start date of the search range for upcoming recurrent delivery. If not given when executing the query, it'll be set to today's date by default. 
     * @param {Date} opts.endDate The end date of the search range for upcoming recurrent delivery. If not given when executin the query, it'll be set seven days after the start date by default. 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Delivery>} and HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesListNextUpcomingOrdersWithHttpInfo",
    value: function appApisV1RecurrentSchedulesListNextUpcomingOrdersWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'location_uuid': opts['locationUuid'],
        'start_date': opts['startDate'],
        'end_date': opts['endDate']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_Delivery["default"]];
      return this.apiClient.callApi('/recurrent-schedules/upcoming-orders', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * List upcoming delivery to orders for a kitchen's location within a date range
     * **scope**: schedules:read 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @param {Date} opts.startDate The start date of the search range for upcoming recurrent delivery. If not given when executing the query, it'll be set to today's date by default. 
     * @param {Date} opts.endDate The end date of the search range for upcoming recurrent delivery. If not given when executin the query, it'll be set seven days after the start date by default. 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Delivery>}
     */

  }, {
    key: "appApisV1RecurrentSchedulesListNextUpcomingOrders",
    value: function appApisV1RecurrentSchedulesListNextUpcomingOrders(opts) {
      return this.appApisV1RecurrentSchedulesListNextUpcomingOrdersWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * List all recurrent deliver schedules
     * **scope**: schedules:read 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1RecurrentSchedulesListSchedules200Response} and HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesListSchedulesWithHttpInfo",
    value: function appApisV1RecurrentSchedulesListSchedulesWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'location_uuid': opts['locationUuid'],
        'page': opts['page'],
        'per_page': opts['perPage']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AppApisV1RecurrentSchedulesListSchedules200Response["default"];
      return this.apiClient.callApi('/recurrent-schedules', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * List all recurrent deliver schedules
     * **scope**: schedules:read 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1RecurrentSchedulesListSchedules200Response}
     */

  }, {
    key: "appApisV1RecurrentSchedulesListSchedules",
    value: function appApisV1RecurrentSchedulesListSchedules(opts) {
      return this.appApisV1RecurrentSchedulesListSchedulesWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Skip one day for multiple locations concerning one event
     * **scope**: schedules:write 
     * @param {module:model/EventSkipDayRequest} eventSkipDayRequest Event skip day request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1RecurrentSchedulesListSchedules200Response} and HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesSkipDayWithHttpInfo",
    value: function appApisV1RecurrentSchedulesSkipDayWithHttpInfo(eventSkipDayRequest) {
      var postBody = eventSkipDayRequest; // verify the required parameter 'eventSkipDayRequest' is set

      if (eventSkipDayRequest === undefined || eventSkipDayRequest === null) {
        throw new Error("Missing the required parameter 'eventSkipDayRequest' when calling appApisV1RecurrentSchedulesSkipDay");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AppApisV1RecurrentSchedulesListSchedules200Response["default"];
      return this.apiClient.callApi('/recurrent-schedules/skip-event', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Skip one day for multiple locations concerning one event
     * **scope**: schedules:write 
     * @param {module:model/EventSkipDayRequest} eventSkipDayRequest Event skip day request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1RecurrentSchedulesListSchedules200Response}
     */

  }, {
    key: "appApisV1RecurrentSchedulesSkipDay",
    value: function appApisV1RecurrentSchedulesSkipDay(eventSkipDayRequest) {
      return this.appApisV1RecurrentSchedulesSkipDayWithHttpInfo(eventSkipDayRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update event for multiple locations
     * **scope**: schedules:write 
     * @param {module:model/EventEditionRequest} eventEditionRequest Event edition request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1RecurrentSchedulesListSchedules200Response} and HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesUpdateEventWithHttpInfo",
    value: function appApisV1RecurrentSchedulesUpdateEventWithHttpInfo(eventEditionRequest) {
      var postBody = eventEditionRequest; // verify the required parameter 'eventEditionRequest' is set

      if (eventEditionRequest === undefined || eventEditionRequest === null) {
        throw new Error("Missing the required parameter 'eventEditionRequest' when calling appApisV1RecurrentSchedulesUpdateEvent");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AppApisV1RecurrentSchedulesListSchedules200Response["default"];
      return this.apiClient.callApi('/recurrent-schedules/edit-event', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update event for multiple locations
     * **scope**: schedules:write 
     * @param {module:model/EventEditionRequest} eventEditionRequest Event edition request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1RecurrentSchedulesListSchedules200Response}
     */

  }, {
    key: "appApisV1RecurrentSchedulesUpdateEvent",
    value: function appApisV1RecurrentSchedulesUpdateEvent(eventEditionRequest) {
      return this.appApisV1RecurrentSchedulesUpdateEventWithHttpInfo(eventEditionRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update recurrent schedule
     * **scope**: schedules:write 
     * @param {String} recurrentScheduleUuid 
     * @param {module:model/RecurrentScheduleUpdateRequest} recurrentScheduleUpdateRequest recurrent schedule
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/RecurrentSchedule} and HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesUpdateScheduleWithHttpInfo",
    value: function appApisV1RecurrentSchedulesUpdateScheduleWithHttpInfo(recurrentScheduleUuid, recurrentScheduleUpdateRequest) {
      var postBody = recurrentScheduleUpdateRequest; // verify the required parameter 'recurrentScheduleUuid' is set

      if (recurrentScheduleUuid === undefined || recurrentScheduleUuid === null) {
        throw new Error("Missing the required parameter 'recurrentScheduleUuid' when calling appApisV1RecurrentSchedulesUpdateSchedule");
      } // verify the required parameter 'recurrentScheduleUpdateRequest' is set


      if (recurrentScheduleUpdateRequest === undefined || recurrentScheduleUpdateRequest === null) {
        throw new Error("Missing the required parameter 'recurrentScheduleUpdateRequest' when calling appApisV1RecurrentSchedulesUpdateSchedule");
      }

      var pathParams = {
        'recurrent_schedule_uuid': recurrentScheduleUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _RecurrentSchedule["default"];
      return this.apiClient.callApi('/recurrent-schedules/{recurrent_schedule_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update recurrent schedule
     * **scope**: schedules:write 
     * @param {String} recurrentScheduleUuid 
     * @param {module:model/RecurrentScheduleUpdateRequest} recurrentScheduleUpdateRequest recurrent schedule
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/RecurrentSchedule}
     */

  }, {
    key: "appApisV1RecurrentSchedulesUpdateSchedule",
    value: function appApisV1RecurrentSchedulesUpdateSchedule(recurrentScheduleUuid, recurrentScheduleUpdateRequest) {
      return this.appApisV1RecurrentSchedulesUpdateScheduleWithHttpInfo(recurrentScheduleUuid, recurrentScheduleUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Validate events creation for multiple locations
     * **scope**: schedules:read 
     * @param {module:model/EventCreationRequest} eventCreationRequest Event creation request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Delivery>} and HTTP response
     */

  }, {
    key: "appApisV1RecurrentSchedulesValidateEventWithHttpInfo",
    value: function appApisV1RecurrentSchedulesValidateEventWithHttpInfo(eventCreationRequest) {
      var postBody = eventCreationRequest; // verify the required parameter 'eventCreationRequest' is set

      if (eventCreationRequest === undefined || eventCreationRequest === null) {
        throw new Error("Missing the required parameter 'eventCreationRequest' when calling appApisV1RecurrentSchedulesValidateEvent");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_Delivery["default"]];
      return this.apiClient.callApi('/recurrent-schedules/validate-event', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Validate events creation for multiple locations
     * **scope**: schedules:read 
     * @param {module:model/EventCreationRequest} eventCreationRequest Event creation request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Delivery>}
     */

  }, {
    key: "appApisV1RecurrentSchedulesValidateEvent",
    value: function appApisV1RecurrentSchedulesValidateEvent(eventCreationRequest) {
      return this.appApisV1RecurrentSchedulesValidateEventWithHttpInfo(eventCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return DeliverSchedulesApi;
}();

exports["default"] = DeliverSchedulesApi;